<template>
  <div class="wrap"
       id="wrap"
       @click="openUrl"
       :style="{background:data.bg_color,color:data.text_color}"
  >
    <div id="box">
      <div id="marquee">{{text}}</div>
      <div id="copy"></div>
    </div>
    <div id="node">{{text}}</div>
  </div>
</template>
<script>
export default {
  name: 'AdScroll',
  data () {
    return {
      text: '', // 数组文字转化后的字符串,
      isScroll: false
    }
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    openUrl () {
      if (this.data.url) {
        window.location.href = this.data.url
      }
    },
    move () {
      // 获取文字text 的计算后宽度 （由于overflow的存在，直接获取不到，需要独立的node计算）
      const width = document.getElementById('marquee').getBoundingClientRect().width
      const wrapWidth = document.getElementById('wrap').getBoundingClientRect().width - 20
      if (width > wrapWidth) {
        const box = document.getElementById('box')
        const copy = document.getElementById('copy')
        copy.innerText = this.text // 文字副本填充
        let distance = 0 // 位移距离
        // 设置位移
        setInterval(function () {
          distance = distance - 1
          // 如果位移超过文字宽度，则回到起点

          if (-distance >= width) {
            distance = 16
          }
          box.style.transform = 'translateX(' + distance + 'px)'
        }, 30)
      }
    }
  },
  // 把父组件传入的arr转化成字符串
  mounted: function () {
    this.text = ' ' + this.data.text
  },
  // 更新的时候运动
  updated: function () {
    this.move()
  }
}
</script>
<style scoped>
  /*限制外框宽度，隐藏多余的部分*/
  .wrap {
    width:91%;
    height:24px;
    margin: 0 auto;
    padding:0 10px;
    box-sizing: border-box;
    overflow: hidden;
    background: #000000;
    line-height: 24px;
    border-radius: 5px;
    font-size: 14px;
    color: #fff;
    cursor:pointer;
  }
  /*// 移动框宽度设置*/
     #box {
       width: 80000%;
     }
  /*// 文字一行显示*/
     #box div {
       float: left;
     }
  /*// 设置前后间隔*/
     #marquee {
       height:24px;
       margin: 0 16px 0 0;
     }
  /*// 获取宽度的节点，隐藏掉*/
     #node {
       position: absolute;
       z-index: -999;
       top: -999999px;
     }
  @media screen and (min-width: 751px){
    .wrap{
      width: 91%;
    }
  }
</style>
